/**
 * Hilfsfunktionen für Workflow-Komponenten
 */

/**
 * Formatiert ein Datum ins deutsche Format mit Uhrzeit
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '-';
  }
};

/**
 * Gibt die Chipfarbe für einen Workflow-Status zurück
 */
export const getStatusColor = (status: string): 'primary' | 'success' | 'warning' | 'default' => {
  switch (status) {
    case 'Aktiv':
      return 'primary';
    case 'Abgeschlossen':
      return 'success';
    case 'Pausiert':
      return 'warning';
    default:
      return 'default';
  }
};

/**
 * Workflow-Kategorien
 */
export const WORKFLOW_KATEGORIEN = [
  'Rechnung',
  'Support',
  'Bestellung',
  'Reklamation',
  'Terminanfrage',
  'Onboarding',
  'Projekt',
  'Sonstiges',
];

/**
 * Prioritäts-Optionen
 */
export const PRIORITAET_OPTIONEN = ['Niedrig', 'Mittel', 'Hoch', 'Kritisch'];
